/*
export enum Permissions
{
	None = 0,
	Read = 1 << 0,
	Write = 1 << 1,

	AddUsers = 1 << 2,
	RemoveUsers = 1 << 3,
	Metadata = 1 << 4,

	ForceTimelineWrite = 1 << 5,
	MapEdit = 1 << 6,

	Administrate = AddUsers | RemoveUsers,

	ReadWrite = Read | Write,
	All = ReadWrite | Administrate | Metadata,
}*/

export enum Permissions
{
	None = 0,
	ProjectAccess = 1 << 0,
	TimelineCreate = 1 << 1, // TODO: this is the last old perm that needs fixing up
	UserManage = 1 << 2,
	InviteManage = 1 << 3,
	MetadataEdit = 1 << 4,
	TimelineForceWrite = 1 << 5,
	MapEdit = 1 << 6,
	TimelineForceRead = 1 << 7, // TODO: hook this up everywhere it needs to be
	TimelineForceShare = 1 << 8, // TODO: hook this up everywhere it needs to be
	ProjectModerate = 1 << 9,
	UserGroupEdit = 1 << 10,
	ProjectDelete = 1 << 11, 

	All = (1 << 11) - 1, // all 11 bits set TODO: double-check this

	Admin = All,
	Guest = ProjectAccess | TimelineForceRead,
	DefaultMember = ProjectAccess | TimelineCreate | TimelineForceRead,
}

export namespace Permissions
{
	export function check(permission : Permissions, neededPermission : Permissions)
	{
        return ((<number>permission) & (<number>neededPermission)) == (<number>neededPermission);
	}
	
	export function checkAny(permission : Permissions, neededPermission : Permissions)
	{
        return ((<number>permission) & (<number>neededPermission)) != 0;
    }
}